/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileTypeEnum } from './FileTypeEnum';
import {
    FileTypeEnumFromJSON,
    FileTypeEnumFromJSONTyped,
    FileTypeEnumToJSON,
    FileTypeEnumToJSONTyped,
} from './FileTypeEnum';

/**
 * 
 * @export
 * @interface SimulationDocumentDto
 */
export interface SimulationDocumentDto {
    /**
     * 
     * @type {FileTypeEnum}
     * @memberof SimulationDocumentDto
     */
    fileType: FileTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SimulationDocumentDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationDocumentDto
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationDocumentDto
     */
    storedFileId?: string;
    /**
     * 
     * @type {Date}
     * @memberof SimulationDocumentDto
     */
    signatureDate?: Date;
}



/**
 * Check if a given object implements the SimulationDocumentDto interface.
 */
export function instanceOfSimulationDocumentDto(value: object): value is SimulationDocumentDto {
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function SimulationDocumentDtoFromJSON(json: any): SimulationDocumentDto {
    return SimulationDocumentDtoFromJSONTyped(json, false);
}

export function SimulationDocumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationDocumentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fileType': FileTypeEnumFromJSON(json['fileType']),
        'label': json['label'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'storedFileId': json['storedFileId'] == null ? undefined : json['storedFileId'],
        'signatureDate': json['signatureDate'] == null ? undefined : (new Date(json['signatureDate'])),
    };
}

export function SimulationDocumentDtoToJSON(json: any): SimulationDocumentDto {
    return SimulationDocumentDtoToJSONTyped(json, false);
}

export function SimulationDocumentDtoToJSONTyped(value?: SimulationDocumentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileType': FileTypeEnumToJSON(value['fileType']),
        'label': value['label'],
        'fileName': value['fileName'],
        'storedFileId': value['storedFileId'],
        'signatureDate': value['signatureDate'] == null ? undefined : ((value['signatureDate']).toISOString()),
    };
}

